import _debounce from 'lodash/debounce';

import viewStudentsTemplate from './../view-students/view-students.html';
import selectSubstitutionActivityTemplate from './../select-substitution-activity/select-substitution-activity.html';
import showSubstitutionTemplate from './../../informations/working-days/show-substitution/show-substitution.html';
import ChangesHistoryTemplate from './../../../components/changes-history/changes-history-dialog.html';
import template from './realizations-by-employee.html';

class RealizationsComponent {
  constructor(
    $log, $mdDialog, $mdToast, moment,
    RealizationService,
    SubstitutionService,
    ChangesHistoryService
  ) {
    'ngInject';
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.RealizationService = RealizationService;
    this.SubstitutionService = SubstitutionService;
    this.ChangesHistoryService = ChangesHistoryService;

    this.realizations = [];
    this.dateTo = this.moment().toDate();
    this.dateFrom = this.moment().subtract(7, 'days').toDate();
    this.loadPageCallbackWithDebounce = {};
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.substitutions) {
      this.substitutions = Object.assign([], this.substitutions);
    }
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
  }

  paginatorCallback(page = 1, pageSize = 0) {
    let offset = (page - 1) * pageSize;
    if (angular.isUndefined(offset)) {
      offset = 0;
    }

    return this.RealizationService.getByEmployee({
      dateFrom: this.moment(this.dateFrom).format('YYYY-MM-DD'),
      dateTo: this.moment(this.dateTo).format('YYYY-MM-DD'),
      offset,
      limit: pageSize
    }).then(result => {
      this.realizations = result.data.realizations.map(realization => {
        realization.description = {
          value: realization.description,
          substitution: Boolean(realization.substituteActivity),
          substituteActivity: realization.substituteActivity
        };
        return realization;
      });
      return {
        results: result.data.realizations,
        totalResultCount: result.data.total
      };
    });
  }

  setFilter(form) {
    if (form.$invalid) {
      return false;
    }

    this.loadPageCallbackWithDebounce();
  }

  selectSubstitutionActivity(ev) {
    if (this.substitutions.length > 0) {
      const date = this.moment().format('YYYY-MM-DD');
      this.SubstitutionService.getUserActivities(this.me.userId, this.me.employeeId, date).then(activities => {
        this.$mdDialog.show({
          bindToController: true,
          controllerAs: 'ctrl',
          controller: 'SelectSubstitutionActivityController',
          template: selectSubstitutionActivityTemplate,
          locals: {
            substitutions: this.substitutions,
            activities,
            me: this.me
          },
          clickOutsideToClose: true,
          targetEvent: ev
        });
      });
    } else {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Brak przydzielonych zajęć')
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }

  openAttendances(students, ev) {
    if (students.length > 0) {
      this.$mdDialog.show({
        bindToController: true,
        controllerAs: 'ctrl',
        controller: 'ViewStudentsController',
        template: viewStudentsTemplate,
        locals: {students},
        clickOutsideToClose: true,
        targetEvent: ev
      });
    } else {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Brak uczniów na zajęciach')
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }

  openSubstitution(substituteActivityId, ev) {
    if (angular.isDefined(substituteActivityId)) {
      this.SubstitutionService.getActivity(substituteActivityId)
        .then(substituteActivitie => {
          this.$mdDialog.show({
            bindToController: true,
            controllerAs: 'ctrl',
            controller: 'ShowSubstitutionController',
            template: showSubstitutionTemplate,
            locals: {
              substituteActivitie
            },
            clickOutsideToClose: true,
            targetEvent: ev
          });
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    }
  }

  remove(id, ev) {
    ev.stopPropagation();
    const isSubstituteRealization = this.isSubstituteRealization(id);
    this.RealizationService.delete({id, isSubstituteRealization}).then(() => {
      this.loadPageCallbackWithDebounce();
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto realizację')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  isSubstituteRealization(id) {
    for (let i = 0; i < this.realizations.length; i++) {
      if (this.realizations[i].id === id && Boolean(this.realizations[i].substituteActivity)) {
        return true;
      }
    }

    return false;
  }

  isManager() {
    return this.me.roleName === 'MANAGER';
  }

  showChangesHistory(id, ev) {
    ev.stopPropagation();

    this.ChangesHistoryService
      .getRealizationChanges(id)
      .then(changes => {
        this.$mdDialog.show({
          bindToController: true,
          controller: 'ChangesHistoryDialogController',
          controllerAs: 'ctrl',
          template: ChangesHistoryTemplate,
          locals: {
            changes,
            printAction: `/SCR/changesHistory/realizations/${id}?printPdf=true`
          },
          disableParentScroll: true,
          targetEvent: ev
        });
      });
  }
}

export const Realizations = {
  bindings: {
    me: '<',
    substitutions: '<'
  },
  template,
  controller: RealizationsComponent
};
